import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";
import { api } from "../../resources/api";
import { IUser } from "./types";
import { setUser } from "./slice";

export const fetchUserData = createAsyncThunk<IUser, void>(
  "user/fetchUserData",
  async (_, { dispatch }) => {
    try {
      const response = await axiosInstance.get(api.profile.settings.getProfile.GET_PROFILE);
      
      const userData: IUser = {
        id: response.data.id,
        name: response.data.name,
        email: response.data.email,
        phone: response.data.phone,
        balance: response.data.balance,
      };
      
      dispatch(setUser(userData));
      
      return userData;
    } catch (error) {
      throw error;
    }
  }
);

